<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/category">Categorias</router-link></li>
                <li class="breadcrumb-item active" aria-current="page">Nova categoria</li>
            </ol>
        </nav>
        <div class="row" v-if="enable_error_list">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="alert alert-danger">
                    <ol>
                        <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                    </ol>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="card shadow mb-4">
                    <!-- Card Header - Dropdown -->
                    <div class="card-body">
                        <form @submit="save">
                            <div class="row mt-3">
                                <div class="col-xl-8 col-md-8 col-sm-12">
                                    <label for="">Descrição*</label>
                                    <input type="text" class="form-control" placeholder="Ex: Despesas pessoais"
                                        v-model="category.name">
                                </div>
                                 <div class="col-xl-4 col-md-4 col-sm-12">
                                    <label for="">Grupo</label>
                                    <select class="form-control" v-model="category.group">
                                        <option value="" disabled selected>Escolha uma opção</option>
                                        <option value="Contas de Consumo">Contas de Consumo</option>
                                        <option value="RH e DP">Recursos Humanos / Departamento Pessoal</option>
                                        <option value="Societário">Societário</option>
                                        <option value="Impostos">Impostos</option>
                                        <option value="Software">Software</option>
                                        <option value="Marketing e Publicidade">Marketing e Publicidade</option>
                                        <option value="Despesas Extras">Despesas Extras</option>
                                        <option value="Despesas a Identificar">Despesas a Identificar</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-xl-12 col-md-12 col-sm-12">
                                    <button type="submit" :disabled='!isDisabled' class="btn btn-info"><i
                                            class="fa fa-save"></i> Cadastrar</button>
                                    <router-link to="/category" class="btn btn-danger ml-3"><i class="fa fa-times"></i>
                                        Cancelar</router-link>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
export default {

    components: { Loading },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            url_api: '',
            category: {
                name: '',
                group:''
            },
            enable_error_list: false,
            errors: []
        }
    },

    computed: {
        isDisabled: function () {
            return this.category.name != '';
        }
    },
    mounted() {
        this.isLoading = false;
        this.url_api = process.env.VUE_APP_URL_API

    },
    methods: {
        onCancel() { },

        save(event) {
            event.preventDefault();
            this.enable_error_list = false;
            this.isLoading = true;
            api.post('/category', this.category)
                .then(() => {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Categoria cadastrada com sucesso!",
                        type: 'success'
                    });
                    this.category = {};
                }).catch(error => {
                    this.isLoading = false;
                    if (error.status == 422) {
                        let response_errors = error.response.data.errors;
                        this.errors = response_errors;
                        this.enable_error_list = true;
                    }
                    handleRequestErrors(error.status, error);
                })

        }
    }
}
</script>

<style lang="scss" scoped></style>